import { PrankDefinition, Intensity } from './types';

const COMIC_SANS_FONT = '"Comic Sans MS", cursive';
const TEXT_ELEMENT_SELECTOR = 'h1, h2, h3, h4, h5, p, span, a, button, label, td, th, li';
const NORMAL_SWAP_COUNT = 5;
const INTENSE_SWAP_COUNT = 25;
const TICK_MS = 30000;
const INITIAL_DELAY_MS = 1000;

const comicSansPrank: PrankDefinition = {
  namedCode: 'sans',
  hexCode: 'd9a6',
  create: (intensity) => {
    const tagged: HTMLElement[] = [];
    const swapCount = intensity === Intensity.INTENSE ? INTENSE_SWAP_COUNT : NORMAL_SWAP_COUNT;

    const swapSome = () => {
      const allElements = document.querySelectorAll<HTMLElement>(TEXT_ELEMENT_SELECTOR);
      const elements = Array.from(allElements).filter(el => {
        const rect = el.getBoundingClientRect();
        return rect.width > 0 && rect.height > 0 && el.textContent && el.textContent.trim().length > 0;
      });
      if (elements.length === 0) return;

      for (let i = 0; i < swapCount; i++) {
        const el = elements[Math.floor(Math.random() * elements.length)];
        if (el.style.fontFamily === COMIC_SANS_FONT) continue;

        el.style.fontFamily = COMIC_SANS_FONT;
        tagged.push(el);
      }
    };

    const initialDelay = window.setTimeout(swapSome, INITIAL_DELAY_MS);
    const interval = setInterval(swapSome, TICK_MS);

    return () => {
      window.clearTimeout(initialDelay);
      clearInterval(interval);
      tagged.forEach(el => {
        el.style.fontFamily = '';
      });
    };
  },
};

export default comicSansPrank;
